<div class="flex items-center gap-2">
    <p-slider
        [(ngModel)]="value"
        [ngModelOptions]="{ standalone: true }"
        [min]="this.props?.min ?? min()"
        [max]="this.props?.max ?? max()"
        [step]="this.props?.step ?? step()"
        (ngModelChange)="onValueChange($event)"
        (onTouch)="onTouched()"
        [disabled]="this.props?.disabled ?? disabled()"
        [range]="this.props?.rangeMode ?? rangeMode()"
        class="w-full mx-2 flex-1"
    />
    @if (this.props?.showInput ?? showInput()) {
        @if (!(this.props?.rangeMode ?? rangeMode())) {
            <app-phx-input-number
                [(ngModel)]="value"
                [ngModelOptions]="{ standalone: true }"
                [minValue]="this.props?.min ?? min()"
                [maxValue]="this.props?.max ?? max()"
                [step]="this.props?.step ?? step()"
                (ngModelChange)="onValueChange($event)"
                (onTouch)="onTouched?.()"
                [disabled]="this.props?.disabled ?? disabled()"
                class="!w-20 flex-0"
                readonly="true"
                [upDownButtons]="false"
            />
        } @else {
            <app-phx-input-number
                [(ngModel)]="sliderValue1"
                [ngModelOptions]="{ standalone: true }"
                [minValue]="this.props?.min ?? min()"
                [maxValue]="this.props?.max ?? max()"
                [step]="this.props?.step ?? step()"
                (ngModelChange)="onValueChange([$event, sliderValue2])"
                (onTouch)="onTouched?.()"
                [disabled]="this.props?.disabled ?? disabled()"
                class="!w-20 flex-0"
                readonly="true"
                [upDownButtons]="false"
            />
            <div>-</div>
            <app-phx-input-number
                [(ngModel)]="sliderValue2"
                [ngModelOptions]="{ standalone: true }"
                [minValue]="this.props?.min ?? min()"
                [maxValue]="this.props?.max ?? max()"
                [step]="this.props?.step ?? step()"
                (ngModelChange)="onValueChange([sliderValue1, $event])"
                (onTouch)="onTouched?.()"
                [disabled]="this.props?.disabled ?? disabled()"
                class="!w-20 flex-0"
                readonly="true"
                [upDownButtons]="false"
            />
        }
    }
</div>
